module.exports = __webpack_public_path__ + "static/media/003.ab35c70a.jpg";